/* @flow */
import { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  root: {
    paddingBottom: 22,
    marginBottom: 36,
    borderBottom: ({ theme }: ThemeFunction) =>
      `1px solid ${theme.secondaryTagColor}`,
  },
};
